import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./LetturaSicuraPage.scss";
import { Container, Row, Col, Nav } from "react-bootstrap";
import CaseGenerator from "../../CaseGenerator/CaseGenerator";
import { CaseForms } from "../../../helpers/enums";
import Hero from "../../common/Hero/Hero";
import { useTranslation } from "react-i18next";

const LetturaSicuraPage = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState("attiva");
  const user = useSelector((state) => state.auth);
  const profile = user.impersonationActive
    ? user.profileImpersonate
    : user.profile;
  return (
    <div className="LetturaSicuraPage" data-testid="LetturaSicuraPage">
      <Hero
        title={t("cases.lettura_sicura.title")}
        description={t("cases.lettura_sicura.description")}
        backToText={t("common.back.home")}
        backTo={"/"}
        /*helpText={t("cases.lettura_sicura.description")}*/
      />
      <Container>
        <Row>
          <Col className={"section-tab"}>
            <Nav
              activeKey={key}
              onSelect={setKey}
              className="nav-tabs"
              role="tablist"
            >
              <Nav.Item>
                <Nav.Link
                  as="button"
                  eventKey="attiva"
                  id="tab-attiva"
                  aria-controls="panel-attiva"
                  role="tab"
                  aria-selected={key === "attiva"}
                >
                  {t("lettura.active.service")}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as="button"
                  eventKey="disattiva"
                  id="tab-disattiva"
                  aria-controls="panel-disattiva"
                  role="tab"
                  aria-selected={key === "disattiva"}
                >
                  {t("lettura.deactive.service")}
                </Nav.Link>
              </Nav.Item>
            </Nav>
            {key === "attiva" && (
              <CaseGenerator
                type={CaseForms.LetturaSicuraAttiva}
                initialValues={{
                  email: profile.email,
                  mobilePhoneNumber: profile.mobilePhoneNumber,
                  name: profile.name,
                  surname: profile.surname,
                }}
              />
            )}
            {key === "disattiva" && (
              <CaseGenerator type={CaseForms.LetturaSicuraDisattiva} />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

LetturaSicuraPage.propTypes = {};

export default LetturaSicuraPage;
